import type { EventItem, MediaItem, Person } from './types';

export const people: Person[] = [
  {
    id: 'p1',
    name: '张文远',
    courtesyName: '承德',
    generation: 15,
    branch: '杭州本支',
    region: '浙江杭州',
    gender: '男',
    birth: '1861',
    death: '1943',
    origin: '浙江杭州',
    spouseIds: ['p2'],
    childIds: ['p3', 'p5'],
    parentIds: [],
    biography: '清末至民国间主持修谱，重视族学与家训整理，留下多卷手抄谱牒。',
    privacy: 'family',
    status: 'memorial',
    x: 430,
    y: 56
  },
  {
    id: 'p2',
    name: '李氏',
    generation: 15,
    branch: '杭州本支',
    region: '浙江杭州',
    gender: '女',
    birth: '1886',
    death: '1962',
    origin: '浙江绍兴',
    spouseIds: ['p1'],
    childIds: ['p3', 'p5'],
    parentIds: [],
    biography: '持家严谨，保存家书、地契与早期影像资料，为后世整理族史提供线索。',
    privacy: 'family',
    status: 'memorial',
    x: 590,
    y: 56
  },
  {
    id: 'p3',
    name: '张国华',
    generation: 16,
    branch: '长房',
    region: '浙江杭州',
    gender: '男',
    birth: '1908',
    death: '1977',
    origin: '浙江杭州',
    spouseIds: ['p4'],
    childIds: ['p7'],
    parentIds: ['p1', 'p2'],
    biography: '民国时期从事教育与乡里事务，参与续修宗祠碑记。',
    privacy: 'public',
    status: 'verified',
    x: 260,
    y: 160
  },
  {
    id: 'p4',
    name: '王淑贞',
    generation: 16,
    branch: '长房',
    region: '浙江湖州',
    gender: '女',
    birth: '1912',
    death: '1995',
    origin: '浙江湖州',
    spouseIds: ['p3'],
    childIds: ['p7'],
    parentIds: [],
    biography: '整理家中照片与来往书信，口述保存大量家族迁居故事。',
    privacy: 'family',
    status: 'verified',
    x: 405,
    y: 160
  },
  {
    id: 'p5',
    name: '张国栋',
    generation: 16,
    branch: '二房',
    region: '浙江杭州',
    gender: '男',
    birth: '1910',
    death: '1981',
    origin: '浙江杭州',
    spouseIds: ['p6'],
    childIds: ['p9'],
    parentIds: ['p1', 'p2'],
    biography: '经营家族产业，协助迁徙分支登记，保存多册账簿。',
    privacy: 'public',
    status: 'verified',
    x: 640,
    y: 160
  },
  {
    id: 'p6',
    name: '陈玉兰',
    generation: 16,
    branch: '二房',
    region: '浙江杭州',
    gender: '女',
    birth: '1915',
    death: '1998',
    origin: '浙江杭州',
    spouseIds: ['p5'],
    childIds: ['p9'],
    parentIds: [],
    biography: '家族祭祀与文献保管人之一。',
    privacy: 'family',
    status: 'verified',
    x: 785,
    y: 160
  },
  {
    id: 'p7',
    name: '张景明',
    courtesyName: '怀瑾',
    generation: 17,
    branch: '长房',
    region: '浙江杭州',
    gender: '男',
    birth: '1936',
    death: '2010',
    origin: '浙江杭州',
    spouseIds: ['p8'],
    childIds: ['p11', 'p12', 'p13'],
    parentIds: ['p3', 'p4'],
    biography: '长期从事地方志整理，留下家族迁徙、教育与婚姻记录。',
    privacy: 'family',
    status: 'memorial',
    x: 235,
    y: 270
  },
  {
    id: 'p8',
    name: '李秀英',
    generation: 17,
    branch: '长房',
    region: '浙江杭州',
    gender: '女',
    birth: '1938',
    death: '2016',
    origin: '浙江嘉兴',
    spouseIds: ['p7'],
    childIds: ['p11', 'p12', 'p13'],
    parentIds: [],
    biography: '参与家族影像整理，保存上世纪八十年代后的家庭照片。',
    privacy: 'family',
    status: 'memorial',
    x: 410,
    y: 270
  },
  {
    id: 'p9',
    name: '张景辉',
    generation: 17,
    branch: '二房',
    region: '浙江杭州',
    gender: '男',
    birth: '1939',
    death: '2012',
    origin: '浙江杭州',
    spouseIds: ['p10'],
    childIds: ['p14', 'p15'],
    parentIds: ['p5', 'p6'],
    biography: '参与分支续谱，补录迁居上海与海外支系。',
    privacy: 'public',
    status: 'verified',
    x: 635,
    y: 270
  },
  {
    id: 'p10',
    name: '刘惠芳',
    generation: 17,
    branch: '二房',
    region: '上海',
    gender: '女',
    birth: '1941',
    death: '2018',
    origin: '上海',
    spouseIds: ['p9'],
    childIds: ['p14', 'p15'],
    parentIds: [],
    biography: '家族通讯录维护者，保留改革开放后的分支联络资料。',
    privacy: 'family',
    status: 'verified',
    x: 790,
    y: 270
  },
  {
    id: 'p11',
    name: '张景行',
    courtesyName: '行之',
    generation: 18,
    branch: '长房',
    region: '浙江杭州',
    gender: '男',
    birth: '1963',
    origin: '浙江杭州',
    spouseIds: ['p16'],
    childIds: ['p17', 'p18'],
    parentIds: ['p7', 'p8'],
    biography: '生于浙江杭州，大学毕业后从事教育工作。为人谦和，热爱家族文化，致力于家谱数字化与传承。现居杭州，与家人共同生活。',
    privacy: 'family',
    status: 'verified',
    x: 235,
    y: 390
  },
  {
    id: 'p16',
    name: '王静',
    generation: 18,
    branch: '长房',
    region: '浙江杭州',
    gender: '女',
    birth: '1965',
    origin: '浙江杭州',
    spouseIds: ['p11'],
    childIds: ['p17', 'p18'],
    parentIds: [],
    biography: '从事公共文化服务，协助整理家族口述史与扫描件。',
    privacy: 'family',
    status: 'verified',
    x: 405,
    y: 390
  },
  {
    id: 'p12',
    name: '张子涵',
    generation: 18,
    branch: '长房',
    region: '浙江宁波',
    gender: '女',
    birth: '1992',
    origin: '浙江宁波',
    spouseIds: [],
    childIds: [],
    parentIds: ['p7', 'p8'],
    biography: '负责海外亲属资料联络与照片归档。',
    privacy: 'private',
    status: 'pending',
    x: 145,
    y: 515
  },
  {
    id: 'p13',
    name: '张子墨',
    generation: 18,
    branch: '长房',
    region: '浙江杭州',
    gender: '男',
    birth: '1995',
    origin: '浙江杭州',
    spouseIds: [],
    childIds: [],
    parentIds: ['p7', 'p8'],
    biography: '维护电子族谱系统数据结构与导入模板。',
    privacy: 'family',
    status: 'pending',
    x: 290,
    y: 515
  },
  {
    id: 'p14',
    name: '张子谦',
    generation: 18,
    branch: '二房',
    region: '上海',
    gender: '男',
    birth: '1998',
    origin: '上海',
    spouseIds: [],
    childIds: [],
    parentIds: ['p9', 'p10'],
    biography: '参与影像资料修复与命名规范整理。',
    privacy: 'family',
    status: 'verified',
    x: 625,
    y: 515
  },
  {
    id: 'p15',
    name: '张子悦',
    generation: 18,
    branch: '二房',
    region: '上海',
    gender: '女',
    birth: '2001',
    origin: '上海',
    spouseIds: [],
    childIds: [],
    parentIds: ['p9', 'p10'],
    biography: '补充家族动态与重要事件时间线。',
    privacy: 'public',
    status: 'verified',
    x: 770,
    y: 515
  },
  {
    id: 'p17',
    name: '张沐阳',
    generation: 19,
    branch: '长房',
    region: '浙江杭州',
    gender: '男',
    birth: '2020',
    origin: '浙江杭州',
    spouseIds: [],
    childIds: [],
    parentIds: ['p11', 'p16'],
    biography: '家族新生代成员，资料仅家族成员可见。',
    privacy: 'private',
    status: 'verified',
    x: 180,
    y: 635
  },
  {
    id: 'p18',
    name: '张沐辰',
    generation: 19,
    branch: '长房',
    region: '浙江杭州',
    gender: '男',
    birth: '2022',
    origin: '浙江杭州',
    spouseIds: [],
    childIds: [],
    parentIds: ['p11', 'p16'],
    biography: '家族新生代成员，资料仅家族成员可见。',
    privacy: 'private',
    status: 'verified',
    x: 340,
    y: 635
  }
];

export const events: EventItem[] = [
  { id: 'e1', year: '1963', title: '出生', description: '出生于浙江杭州。', type: 'birth' },
  { id: 'e2', year: '1983', title: '大学毕业', description: '毕业后进入教育系统。', type: 'education' },
  { id: 'e3', year: '1987', title: '结婚', description: '与王静成婚。', type: 'marriage' },
  { id: 'e4', year: '1992', title: '长子出生', description: '张子涵出生。', type: 'birth' },
  { id: 'e5', year: '2024', title: '数字修谱', description: '发起家族数字档案整理。', type: 'archive' }
];

export const media: MediaItem[] = [
  { id: 'm1', personId: 'p11', title: '童年照', year: '1963', type: 'photo' },
  { id: 'm2', personId: 'p11', title: '毕业照', year: '1983', type: 'photo' },
  { id: 'm3', personId: 'p11', title: '婚礼合影', year: '1987', type: 'photo' },
  { id: 'm4', personId: 'p11', title: '出生记录', year: '1992', type: 'document' }
];
